import {RouteObject} from 'react-router-dom';
import {ProtectedRoute} from '../auth/require-authorization';
import {ROUTES} from '../routes';
import {
  EmailEvaluationCreate,
  EmailEvaluationUpdate,
} from './email-evaluation-create-update';
import {EmailEvaluationListing} from './email-evaluation-listing';
import {AllRoles} from '../navigation/links';

export const EmailEvaluationRoutes: RouteObject = {
  path: ROUTES.ADMIN.EMAIL_EVALUATIONS.path,
  element: <ProtectedRoute role={AllRoles} />,
  children: [
    {
      path: ROUTES.ADMIN.EMAIL_EVALUATIONS.INDEX.path,
      element: <EmailEvaluationListing />,
    },
    {
      path: ROUTES.ADMIN.EMAIL_EVALUATIONS.CREATE.path,
      element: <EmailEvaluationCreate />,
    },
    {
      path: ROUTES.ADMIN.EMAIL_EVALUATIONS.DETAIL.path,
      element: <EmailEvaluationUpdate />,
    },
  ],
};
